import type { CurrentUser } from "@hooks/use-current-user";

export const PREVIEW_USER: CurrentUser = {
  id: "preview-user",
  email: "preview@gnomux.com",
  initials: "PU",
  name: "Preview User",
};

/**
 * Whether this is a Cloudflare branch preview build.
 *
 * Set via VITE_PREVIEW=true in the Workers Builds non-production build
 * command. Baked in at build time; previews bypass Kinde auth with a dummy
 * user and rely on Cloudflare Access for protection.
 */
export function isPreviewBuild(): boolean {
  return import.meta.env.VITE_PREVIEW === "true";
}
